import produce from 'immer';

import {
  UNSUBSCRIBE_REQUESTING,
  UNSUBSCRIBE_FAILED,
  UNSUBSCRIBE_SUCCEEDED,
  RESET_UNSUBSCRIPTION,
  LOGOUT,
} from '../../constants/actionTypes';

import {
  REQUEST_STATE_READY,
  REQUEST_STATE_REQUESTING,
  REQUEST_STATE_FAILED,
  REQUEST_STATE_SUCCEEDED,
} from '../../../constants/state';

const initState = REQUEST_STATE_READY;

export default produce((draft, action) => {
  switch (action.type) {
    case UNSUBSCRIBE_REQUESTING: {
      return REQUEST_STATE_REQUESTING;
    }

    case UNSUBSCRIBE_FAILED: {
      return REQUEST_STATE_FAILED;
    }

    case UNSUBSCRIBE_SUCCEEDED: {
      return REQUEST_STATE_SUCCEEDED;
    }

    case RESET_UNSUBSCRIPTION:
    case LOGOUT: {
      return initState;
    }
  }
}, initState);
